import { ModeSettingEnum } from '@colonist/types';
import { CardEnum, PlayerColor } from '@colonist/game-states';
import CardDevelopmentCardBack from '@static/images/card_devcardback.svg';
import IconKnightUpgrade from '@static/images/icon_knight_upgrade.svg';
import IconSquareActiveTrade from '@static/images/icon_square_active_trade.svg';
import IconSquareActivePolitics from '@static/images/icon_square_active_politics.svg';
import IconSquareActiveScience from '@static/images/icon_square_active_science.svg';
import { ROAD_IMAGE_PATH, SETTLEMENT_IMAGE_PATH, CITY_IMAGE_PATH, SHIP_IMAGE_PATH, CITY_WALL_IMAGE_PATH, KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH, KNIGHT_ACTIVATION_IMAGE_PATH } from '../../../../utils/gamePieces.ts';
var CostInformationPieceTypes = /*#__PURE__*/ function(CostInformationPieceTypes) {
    CostInformationPieceTypes[CostInformationPieceTypes["City"] = 0] = "City";
    CostInformationPieceTypes[CostInformationPieceTypes["Settlement"] = 1] = "Settlement";
    CostInformationPieceTypes[CostInformationPieceTypes["Road"] = 2] = "Road";
    CostInformationPieceTypes[CostInformationPieceTypes["DevelopmentCard"] = 3] = "DevelopmentCard";
    CostInformationPieceTypes[CostInformationPieceTypes["Ship"] = 4] = "Ship";
    CostInformationPieceTypes[CostInformationPieceTypes["CityWall"] = 5] = "CityWall";
    CostInformationPieceTypes[CostInformationPieceTypes["PurchaseKnight"] = 6] = "PurchaseKnight";
    CostInformationPieceTypes[CostInformationPieceTypes["ActivateKnight"] = 7] = "ActivateKnight";
    CostInformationPieceTypes[CostInformationPieceTypes["UpgradeKnight"] = 8] = "UpgradeKnight";
    CostInformationPieceTypes[CostInformationPieceTypes["Science"] = 9] = "Science";
    CostInformationPieceTypes[CostInformationPieceTypes["Trade"] = 10] = "Trade";
    CostInformationPieceTypes[CostInformationPieceTypes["Politics"] = 11] = "Politics";
    return CostInformationPieceTypes;
}(CostInformationPieceTypes || {});
const baseGameCostsInformation = [
    {
        piece: 2,
        cost: [
            CardEnum.Lumber,
            CardEnum.Brick
        ],
        title: {
            key: 'strings:game.PieceTypes.Road'
        }
    },
    {
        piece: 1,
        cost: [
            CardEnum.Lumber,
            CardEnum.Brick,
            CardEnum.Wool,
            CardEnum.Grain
        ],
        title: {
            key: 'strings:game.PieceTypes.Settlement'
        }
    },
    {
        piece: 0,
        cost: [
            CardEnum.Grain,
            CardEnum.Grain,
            CardEnum.Ore,
            CardEnum.Ore,
            CardEnum.Ore
        ],
        title: {
            key: 'strings:game.PieceTypes.City'
        }
    }
];
const developmentCostInformation = [
    {
        piece: 3,
        cost: [
            CardEnum.Wool,
            CardEnum.Grain,
            CardEnum.Ore
        ],
        title: {
            key: 'strings:game.PieceTypes.DevelopmentCard',
            options: {
                context: 'Abbreviated'
            }
        }
    }
];
const seafarersCosts = [
    {
        piece: 4,
        cost: [
            CardEnum.Lumber,
            CardEnum.Wool
        ],
        title: {
            key: 'strings:game.PieceTypes.Ship'
        }
    }
];
const citiesAndKnightsCosts = [
    {
        piece: 5,
        cost: [
            CardEnum.Brick,
            CardEnum.Brick
        ],
        title: {
            key: 'strings:game.PieceTypes.CityWall'
        }
    },
    {
        piece: 6,
        cost: [
            CardEnum.Wool,
            CardEnum.Ore
        ],
        title: {
            key: 'strings:game.tooltips.purchaseKnight'
        }
    },
    {
        piece: 7,
        cost: [
            CardEnum.Grain
        ],
        title: {
            key: 'strings:game.gameState.actions.activateKnightSelf'
        }
    },
    {
        piece: 8,
        cost: [
            CardEnum.Wool,
            CardEnum.Ore
        ],
        title: {
            key: 'strings:game.gameState.actions.upgradeKnightSelf'
        }
    },
    {
        piece: 9,
        cost: [
            CardEnum.Paper
        ],
        title: {
            key: 'strings:game.cards.progress.title.Science'
        }
    },
    {
        piece: 10,
        cost: [
            CardEnum.Cloth
        ],
        title: {
            key: 'strings:game.cards.progress.title.Trade'
        }
    },
    {
        piece: 11,
        cost: [
            CardEnum.Coin
        ],
        title: {
            key: 'strings:game.cards.progress.title.Politics'
        }
    }
];
export function getCostInformation(gameMode) {
    switch(gameMode){
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return [
                ...baseGameCostsInformation,
                ...developmentCostInformation,
                ...seafarersCosts
            ];
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return [
                ...baseGameCostsInformation,
                ...citiesAndKnightsCosts
            ];
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [
                ...baseGameCostsInformation,
                ...seafarersCosts,
                ...citiesAndKnightsCosts
            ];
        default:
            return [
                ...baseGameCostsInformation,
                ...developmentCostInformation
            ];
    }
}
export function getPieceIconPath(piece, color) {
    const isPlayerSpectator = color === 0;
    color = isPlayerSpectator ? PlayerColor.Blue : color;
    switch(piece){
        case 2:
            return ROAD_IMAGE_PATH[color];
        case 1:
            return SETTLEMENT_IMAGE_PATH[color];
        case 0:
            return CITY_IMAGE_PATH[color];
        case 3:
            return CardDevelopmentCardBack;
        case 4:
            return SHIP_IMAGE_PATH[color];
        case 5:
            return CITY_WALL_IMAGE_PATH[color];
        case 6:
            return KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH[color];
        case 7:
            return KNIGHT_ACTIVATION_IMAGE_PATH[color];
        case 8:
            return IconKnightUpgrade;
        case 10:
            return IconSquareActiveTrade;
        case 11:
            return IconSquareActivePolitics;
        case 9:
            return IconSquareActiveScience;
    }
}
